import { z } from 'zod'

export const convertLeadSchema = z.object({
  dealName:            z.string().min(1, 'Deal name is required'),
  dealStage:           z.string().min(1, 'Deal stage is required'),
  expectedClosingDate: z.string()
    .min(1, 'Expected closing date is required')
    .refine((val) => {
      if (!val) return false;
      const date = new Date(val);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      date.setHours(0, 0, 0, 0);
      return date >= today;
    }, { message: 'Expected closing date cannot be in the past' }),
  amount:              z.string()
    .min(1, 'Amount is required')
    .refine((val) => {
      const num = parseFloat(val);
      return !isNaN(num) && num >= 1;
    }, { message: 'Amount must be at least 1' }),
  company:             z.string().min(1, 'Company is required'),
  contact:             z.string().optional(),
  owner:               z.string().optional(),
  source:              z.string().optional(),
  description:         z.string().optional(),
  priority:            z.string().optional(),
  customerTypeId:      z.number({ message: 'Customer type is required' }).int().positive('Customer type is required'),
})

export type ConvertLeadFormData = z.infer<typeof convertLeadSchema>
